// TODO: refactor this

import $ from 'jquery';
import mapboxgl from 'mapbox-gl';
import { debugLog } from './enci.log.js';
import {
    addFullscreenControl,
    addStyleSelectionButtons,
    addLegend,
    addSatelliteView,
    fixBounds,
    setPrefs,
    handleSatelliteView,
    handleFullscreenControl,
    prepareSourceStyles,
} from './enci.mapbox.util.js';

import '../../../wwwroot/css/mapbox-gl.css';

const streetMapStyle = 'mapbox://styles/energynet/ciutxrw2300542innviqfjco9?optimize=true';
const satelliteStyle = 'mapbox://styles/energynet/ciuzk55rf004z2ikhxn16064w?optimize=true';

const streetMapStyleGovt = 'mapbox://styles/energynet/citx71xus00ag2io6kbh2imln';
const satelliteStyleGovt = 'mapbox://styles/energynet/citxbeqft00b12io6zapk6aaw';

mapboxgl.accessToken =
    'pk.eyJ1IjoiZW5lcmd5bmV0IiwiYSI6ImNpdDV6cTIyYjAyMnMyeWxqazM1MTh6c2UifQ.ZzFT91_CFIox65C151SSfw';

const zoomShowPolygons = $('#map').data('zoom-show-polygons') || 7;

const mapPromises = [];
const defaultBBox = [-124.848974, 24.396308, -66.885444, 49.384358]; // Extents of continental US
const saleGroupData = {};
const lotData = {};
// Save bounding boxes
let allBBox = [];

// Load each sale group json file into a unified geojson
const geojsonData = { type: 'FeatureCollection', features: [] };

let map;
let prefs;

async function loadGeoJson(url, isUrl) {
    debugLog('loadGeoJson', { obj: url });

    if (!isUrl) {
        return parseResponse(url);
    }

    return fetch(url)
        .then(response => {
            if (!response.ok) {
                throw new Error(`Network response was not ok: ${response.statusText}`);
            }
            return response.json();
        })
        .then(data => {
            return parseResponse(data);
        })
        .catch(error => {
            console.error('Failed to load GeoJSON data:', error);
            return {
                geojson_data: { type: 'FeatureCollection', features: [] },
                boundingBox: null,
                error,
            };
        });
}

async function parseResponse(data) {

    try {

        const geojson_data = {
            type: 'FeatureCollection',
            features: data.features,
        };

        // Calculate the bounding box
        let boundingBox = [Infinity, Infinity, -Infinity, -Infinity]; // min long, min lat, max long, max lat
        data.features.forEach(feature => {
            const coords = feature.geometry.coordinates;
            boundingBox[0] = Math.min(boundingBox[0], coords[0]);
            boundingBox[1] = Math.min(boundingBox[1], coords[1]);
            boundingBox[2] = Math.max(boundingBox[2], coords[0]);
            boundingBox[3] = Math.max(boundingBox[3], coords[1]);
        });

        return { geojson_data, boundingBox };

    } catch (error) {
        console.error('Failed to load GeoJSON data:', error);
        return {
            geojson_data: { type: 'FeatureCollection', features: [] },
            boundingBox: null,
            error,
        };
    }
}

async function initializeMapData(geoJsonUrl, shouldLoadUrl) {
    debugLog('initializeMapData');

    await loadGeoJson(geoJsonUrl, shouldLoadUrl).then(
        ({ geojson_data, boundingBox }) => {
            if (!geojson_data) {
                console.error('No features to display on the map.');
                return;
            }

            if (map) {

                // Remove the source & layer if the exist so this method can be called more than once...
                if (map.getLayer("en_point")) {
                    map.removeLayer("en_point");
                }
                if (map.getSource("en_data")) {
                    map.removeSource("en_data");
                }

                map.addSource('en_data', {
                    type: 'geojson',
                    data: geojson_data,
                });

                /*
                map.addLayer({
                    id: 'en_point',
                    type: 'symbol',
                    source: 'en_data',
                    layout: {
                        'icon-image': '{lot_type}_marker',
                        'icon-allow-overlap': true,
                    },
                    paint: {
                        'icon-opacity': 0.8,
                    },
                });
                */

                map.addLayer({
                    id: 'en_point',
                    type: 'circle',
                    source: 'en_data',
                    paint: {
                        'circle-radius': 10,
                        'circle-color': '#007cbf'
                    }
                });


                if (geojson_data.features.length > 0) {
                    map.fitBounds(
                        [
                            [boundingBox[0], boundingBox[1]],
                            [boundingBox[2], boundingBox[3]],
                        ],
                        {
                            padding: 20,
                        }
                    );
                }

                map.resize(); // Ensure proper size after load

                // setupMapInteractions();
            } else {
                console.error('Map instance is not initialized.');
            }
        });
}

// Show/Hide Map

function showMap() {
    $('.container-map').slideDown();
    $('.map-toggle').text('Hide Map');
    map.resize();

    if (!prefs.showMap) {
        prefs.showMap = true;
        localStorage.setItem('govt_list_prefs', JSON.stringify(prefs));
    }
}

function hideMap() {
    $('.container-map').slideUp();
    $('.map-toggle').text('Show Map');

    if (prefs.showMap) {
        prefs.showMap = false;
        localStorage.setItem('govt_list_prefs', JSON.stringify(prefs));
    }
}

function setToggleMap() {
    $('.map-toggle-collapse, .map-toggle').on('click', function () {
        $('.container-map').is(':visible') ? hideMap() : showMap();
    });
}

function setupMapInteractionsBase() {
    //Highlight lots and show data on hover
    const popup = new mapboxgl.Popup({
        closeButton: false,
        closeOnClick: false,
    });

    let highlightedLot = null; // Which lot feature is highlighted
    let clickedLot = null; // Which lot feature is clicked

    return { popup, highlightedLot, clickedLot };
}

function setupMapInteractions() {
    let { popup, highlightedLot, clickedLot } = setupMapInteractionsBase();

    map.on('mousemove', function (e) {
        // Search displayed lot circles and polygons
        const features = map.queryRenderedFeatures(e.point, {
            layers: ['en_point'],
        });

        map.getCanvas().style.cursor = features.length ? 'pointer' : '';

        // Disable hover behavior if a lot is clicked
        if (clickedLot != null) {
            return;
        }

        if (!features.length && highlightedLot != null) {
            highlightedLot = null;
            popup.remove();
        } else if (features.length && highlightedLot != features[0].properties.lot_no) {
            highlightedLot = features[0].properties.lot_no;
            var clickLocation = features[0].geometry.coordinates; //e.lngLat;

            var popupData = [];
            var popupHtml = '';

            for (var feature in features) {
                // Only show popup for first property and any other property with exact same coordinates (this will be true for commercial lots with same county)
                if (
                    clickLocation[0] === features[feature].geometry.coordinates[0] &&
                    clickLocation[1] === features[feature].geometry.coordinates[1]
                ) {
                    // Get lot #, lot type, and short description
                    var lotData = [
                        features[feature].properties.lot_no,
                        features[feature].properties.lot_type,
                        features[feature].properties.short_desc,
                    ];
                    popupData.push(lotData);
                }
            }

            if (popupData.length == 1) {
                var link =
                    '<a role="button" class="btn btn-xs btn-info btn-' +
                    popupData[0][1] +
                    '" href="property_information.pl?lot=' +
                    popupData[0][0] +
                    '">Property Info</a>';
                popupHtml +=
                    "<div class='hover'><div class='lot-no'>Lot " +
                    popupData[0][0] +
                    "</div><div class='lot-descr'>" +
                    popupData[0][2] +
                    '</div><div>' +
                    link +
                    '</div>' +
                    '</div>';
            } else if (popupData.length > 1) {
                popupHtml += 'Multiple lots in this location/county...';
                for (var lot in popupData) {
                    popupHtml +=
                        "<div class='hover'><span class='lot-no'>Lot " +
                        popupData[lot][0] +
                        '&nbsp&nbsp&nbsp</span><a role="button" class="btn btn-xs btn-info btn-' +
                        popupData[lot][1] +
                        '" href="property_information.pl?lot=' +
                        popupData[lot][0] +
                        '">Property Info</a></div>';
                }
            } else {
                return;
            }

            popup.setHTML(popupHtml).setLngLat(clickLocation).addTo(map);
        }
    });

    map.on('click', function (e) {
        var features = map.queryRenderedFeatures(e.point, {
            layers: ['en_point'],
        }); //Search displayed lot circles and polygons

        var numFeatures = features.length; //More than 5 lots in query
        var maxLotsInPopup = 5;

        if (highlightedLot != null) {
            //Remove hover popup on click
            highlightedLot = null;
            clickedLot = null;
            popup.remove();
        }

        //Only call this code if the mouse is over a feature and the feature is not currently highlighted
        if (!features.length && clickedLot != null) {
            clickedLot = null;
            popup.remove();
        } else if (features.length && clickedLot != features[0].properties.lot_no) {
            clickedLot = features[0].properties.lot_no;
            var clickLocation = e.lngLat; //features[0].geometry.coordinates

            var popupData = [];
            var popupHtml = '';

            for (var feature in features) {
                if (feature == maxLotsInPopup) {
                    break;
                }
                var lotData = [
                    features[feature].properties.lot_no,
                    features[feature].properties.lot_type,
                    features[feature].properties.short_desc,
                ];
                popupData.push(lotData);
            }

            if (popupData.length == 1) {
                var link =
                    '<a role="button" class="btn btn-xs btn-info btn-' +
                    popupData[0][1] +
                    '" href="property_information.pl?lot=' +
                    popupData[0][0] +
                    '">Property Info</a>';
                popupHtml +=
                    "<div class='hover'><div class='lot-no'>Lot " +
                    popupData[0][0] +
                    "</div><div class='lot-descr'>" +
                    popupData[0][2] +
                    '</div><div>' +
                    link +
                    '</div>' +
                    '</div>';
            } else if (popupData.length > 1) {
                popupHtml += 'Multiple lots in this location/county...';
                for (var lot in popupData) {
                    popupHtml +=
                        "<div class='hover'><span class='lot-no'>Lot " +
                        popupData[lot][0] +
                        '&nbsp&nbsp&nbsp</span><a role="button" class="btn btn-xs btn-info btn-' +
                        popupData[lot][1] +
                        '" href="property_information.pl?lot=' +
                        popupData[lot][0] +
                        '">Property Info</a></div>';
                }
                if (numFeatures > maxLotsInPopup) {
                    var remainingLots = numFeatures - maxLotsInPopup;
                    popupHtml += 'There are ' + remainingLots + ' additional lots at this location.<br>';
                }
                popupHtml += 'Zoom in to see additional lots.';
            } else {
                return;
            }

            popup.setHTML(popupHtml).setLngLat(clickLocation).addTo(map);
        }
    });

    map.on('zoom', function () {
        //Remove clicked popup on zoom
        if (clickedLot != null) {
            clickedLot = null;
            popup.remove();
        }
    });

    //Save sources and layers for repopulating styles after changing styles
    prepareSourceStyles(map);

    // Full window expand map control
    handleFullscreenControl(map);

    //Switch Map view between Street Map and Satellite, since we just have two buttons, just toggle active class
    handleSatelliteView(prefs, 'cartographer_prefs', map, streetMapStyle, satelliteStyle);
}

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

async function prepareMap(prefsKey) {
    debugLog('createMap');

    const $map = $('#map');

    if (!$map.length || typeof mapboxgl === 'undefined') {
        debugLog('createMap >> No map id found.');
        return;
    }

    debugLog('createMap >> moving forward with map');

    prefs = setPrefs(prefsKey);
    debugLog('createMap >> prefs set', { obj: prefs });

    if (!mapboxgl.supported()) {
        $('.mapbox-error').show();
        return;
    }
    debugLog('createMap >> mapboxgl supported');

    map = new mapboxgl.Map({
        container: 'map',
        style: prefs.mapSatelliteView ? satelliteStyle : streetMapStyle,
        minZoom: 2,
        center: [-100.0, 36.0],
    });

    debugLog('createMap >> map created');

    map.on('error', (e) => {
        console.error('Mapbox error:', e.error.message);
    });

    let mapLoadPromise = new Promise((resolve) => { // , reject
        map.on('load', resolve);
    });

    mapPromises.push(mapLoadPromise);

    debugLog('createMap >> resolved promises.  Adding controls.');

    map.addControl(new mapboxgl.NavigationControl());

    map.addControl(
        new mapboxgl.ScaleControl({
            position: 'bottom-right',
            unit: 'imperial',
        })
    );

    addFullscreenControl();
    addStyleSelectionButtons();
    addLegend();
    addSatelliteView(prefs);

    // Set some options
    map.scrollZoom.disable();
    map.dragRotate.disable();
    map.touchZoomRotate.disableRotation();

    // Enable map scroll only only after click on map, disable when mouse leaves map
    map.on('mousedown', function () {
        map.scrollZoom.enable();
    });

    $(window).scroll(function () {
        map.scrollZoom.disable();
    });
}

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

function setupMapInteractionsGovt(saleGroupData, lotData) {
    let { popup, highlightedLot, clickedLot } = setupMapInteractionsBase();

    map.on('mousemove', function (e) {
        // Search displayed lot circles and polygons
        const features = map.queryRenderedFeatures(e.point, {
            layers: ['en_govt_point', 'en_govt_p'],
        });

        map.getCanvas().style.cursor = features.length ? 'pointer' : '';

        // Disable hover behavior if a lot is clicked
        if (clickedLot != null) {
            return;
        }

        // Only call this code if the mouse is over a feature and the feature is not currently highlighted
        if (!features.length && highlightedLot != null) {
            highlightedLot = null;
            map.setFilter('en_govt_hover_p', ['==', 'lot_no', '']);
            map.setFilter('en_govt_hover_l', ['==', 'lot_no', '']);
            popup.remove();
        } else if (features.length && highlightedLot !== features[0].properties.lot_no) {
            highlightedLot = features[0].properties.lot_no;
            map.setFilter('en_govt_hover_p', ['==', 'lot_no', highlightedLot]);
            map.setFilter('en_govt_hover_l', ['==', 'lot_no', highlightedLot]);

            const p = features[0].properties;

            popup
                .setHTML(
                    "<div class='hover'>" +
                    "<img src='" +
                    saleGroupData[p.sale_group].logo +
                    "'>" +
                    '<div>' +
                    saleGroupData[p.sale_group].short_code +
                    '</div>' +
                    '<div>' +
                    p.lease_name +
                    '</div>' +
                    '</div>'
                )
                .addTo(map);
        }

        if (features.length) {
            popup.setLngLat(e.lngLat);
        }
    });

    map.on('click', function (e) {
        const features = map.queryRenderedFeatures(e.point, {
            layers: ['en_govt_point', 'en_govt_p'],
        }); // Search displayed lot circles and polygons

        // Only call this code if the mouse is over a feature and the feature is not currently highlighted
        if (!features.length && clickedLot != null) {
            clickedLot = null;
            map.setFilter('en_govt_hover_p', ['==', 'lot_no', '']);
            map.setFilter('en_govt_hover_l', ['==', 'lot_no', '']);
            popup.remove();
        } else if (features.length && clickedLot !== features[0].properties.lot_no) {
            clickedLot = features[0].properties.lot_no;

            map.setFilter('en_govt_hover_p', ['==', 'lot_no', clickedLot]);
            map.setFilter('en_govt_hover_l', ['==', 'lot_no', clickedLot]);

            const padding = Math.min($('#map').height(), $('#map').width()) * 0.375;
            map.fitBounds(fixBounds(lotData[clickedLot].bbox), {
                linear: true,
                padding: padding,
            });

            const p = features[0].properties;

            popup
                .setHTML(
                    "<div class='hover'>" +
                    "<img src='" +
                    saleGroupData[p.sale_group].logo +
                    "'>" +
                    '<div>' +
                    saleGroupData[p.sale_group].short_code +
                    '</div>' +
                    '<div>' +
                    p.lease_name +
                    '</div>' +
                    '<div><a role="button" class="btn btn-xs btn-warning btn-lot-info" href="property_information.pl?lot=' +
                    clickedLot +
                    '">' +
                    saleGroupData[p.sale_group].tract_adjective +
                    ' Info</div>' +
                    '</div>'
                )
                .setLngLat(lotData[clickedLot].centroid)
                .addTo(map);
        }
    });

    // When 'View on Map' button is clicked on a lot
    $('.container-listings').on('click', '.btn-map-lot', function () {
        const lot = $(this).closest('tr').data('lotNumber');
        if (!('bbox' in lotData[lot])) {
            $(this).addClass('disabled');
            return;
        }

        // Show map in case it is hidden
        showMap();

        // Scroll to map
        $('html, body').animate({ scrollTop: $('#map').offset().top - 34 }, 200); // 34 is height of overlayed navbar

        // Zoom to lot
        const padding = Math.min($('#map').height(), $('#map').width()) * 0.375;
        map.fitBounds(fixBounds(lotData[lot].bbox), {
            linear: true,
            padding: padding,
        });

        // Highlight lot
        highlightedLot = lot;
        map.setFilter('en_govt_hover_p', ['==', 'lot_no', '' + highlightedLot]);
        map.setFilter('en_govt_hover_l', ['==', 'lot_no', '' + highlightedLot]);

        // Remove a popup if there is one.
        popup.remove();
        /* TODO show the popup for the lot we clicked. The current method for building the popup data requires
             us to have access to the map's feature object. Unfortunately because there isnt a reliable way to
             perform introspection on the map data if it's out of the viewport, it is difficult for an external
             function to get a reference to the properties. */
    });

    // Save sources and layers for repopulating styles after changing styles
    prepareSourceStyles(map);

    // Full window expand map control
    handleFullscreenControl(map);

    // Switch Map view between Street Map and Satellite, since we just have two buttons, just toggle active class
    handleSatelliteView(prefs, 'govt_list_prefs', map, streetMapStyleGovt, satelliteStyleGovt);
}

function addAdditionalLayersGovt(geojsonData) {
    // Mapbox style 'match' to set color based on style class
    const styleMatch = [
        'match',
        ['get', 'style'],
        'og',
        '#ee6527', // Oil & Gas
        'ag',
        '#e6a30f', // Ag Lease
        're',
        '#466a8b', // Real Estate
        'timber',
        '#133a46',
        'renewable',
        '#476d29',
        'other',
        '#22bae8', // Other Minerals
    /* default, other */ '#22bae8',
    ];

    // Add our geojson source to the map (Mapbox GL JS computes vector tiles client side now using GeoJSON-VT)
    // TODO do  this server side
    map.addSource('en_govt', {
        type: 'geojson',
        data: geojsonData,
    });

    // Style the source data
    map.addLayer({
        id: 'en_govt_point',
        type: 'circle',
        source: 'en_govt',
        minzoom: 0,
        maxzoom: zoomShowPolygons,
        paint: {
            'circle-color': styleMatch,
            'circle-radius': 6,
            'circle-opacity': 0.8,
        },
        filter: ['==', '$type', 'Point'],
    });

    map.addLayer({
        id: 'en_govt_p',
        type: 'fill',
        source: 'en_govt',
        minzoom: zoomShowPolygons,
        // maxzoom: 15,
        paint: {
            'fill-color': styleMatch,
            'fill-opacity': 0.1,
        },
        filter: ['==', '$type', 'Polygon'],
    });

    map.addLayer({
        id: 'en_govt_l',
        type: 'line',
        source: 'en_govt',
        minzoom: zoomShowPolygons,
        paint: {
            'line-color': styleMatch,
            'line-width': 3,
        },
        filter: ['==', '$type', 'Polygon'],
    });

    // These two styles are used to highlight polygons and outlines on hover, hance why they have an "impossible" filter
    map.addLayer({
        id: 'en_govt_hover_p',
        type: 'fill',
        source: 'en_govt',
        minzoom: zoomShowPolygons,
        paint: {
            'fill-color': '#00b239',
            'fill-opacity': 0.2,
        },
        filter: ['all', ['==', '$type', 'Polygon'], ['==', 'lot_no', '']],
    });

    map.addLayer({
        id: 'en_govt_hover_l',
        type: 'line',
        source: 'en_govt',
        minzoom: zoomShowPolygons,
        paint: {
            'line-color': '#00ff52',
            'line-width': 3,
        },
        filter: ['all', ['==', '$type', 'Polygon'], ['==', 'lot_no', '']],
    });

    // Fit the map bounds to our precomputed bounding box, or else use the default bounding box
    map.fitBounds(fixBounds(allBBox.length ? allBBox : defaultBBox), {
        linear: true,
        padding: 20,
    });
}

async function initializeMapDataGovt(selector) {
    // Try to fetch a geojson for each sale group
    $(selector).each(function () {
        let sgbbox = $(this).data('map-coordinates').map(Number);

        // Wrap the ajax in our own deferred because these can fail due to missing data
        const ajaxDeferredWrapper = $.Deferred();
        mapPromises.push(ajaxDeferredWrapper);

        $.ajax({
            url: 'maps/sg_' + $(this).data('saleGroup') + '.geojson.json',
            dataType: 'json',
        })
            .done(function (data) {
                // Process the geojson data
                let sg;
                // Process the incoming GeoJSON data
                if ('metadata' in data && 'sale_group' in data.metadata) {
                    sg = parseInt(data.metadata.sale_group);
                    // Create and populate the sale group in saleGroupData
                    if (!(sg in saleGroupData)) {
                        saleGroupData[sg] = {};
                        const logo = data.metadata.sale_group_logo;
                        if (logo != null) {
                            saleGroupData[sg].logo = logo;
                        }

                        saleGroupData[sg].short_code = data.metadata.sale_group_short_code;
                        saleGroupData[sg].tract_adjective = data.metadata.sale_group_tract_adjective;
                    }
                }

                // See if we have a bounding box for this sale group
                if ('bbox' in data && sg != null) {
                    sgbbox = data.bbox;
                    // Save the bounding box for the sale group
                    saleGroupData[sg].bbox = sgbbox;
                }

                // Process the lot features
                for (let i = 0; i < data.features.length; i++) {
                    const feature = data.features[i];
                    // eslint-disable-next-line camelcase
                    let lot_no = null;

                    // Create and populate the lot in lotData
                    if ('properties' in feature && 'lot_no' in feature.properties) {
                        // If this feature does not correspond to a listed lot, skip it
                        if (!(feature.properties.lot_no in lotData)) {
                            continue;
                        }
                        // eslint-disable-next-line camelcase
                        lot_no = feature.properties.lot_no;
                    } else {
                        // If we have no lot number, skip this feature
                        continue;
                    }

                    // Add the sale group id to this feature and push it into the map source layer
                    if (sg != null) {
                        feature.properties.sale_group = sg;
                    }

                    // We store the point geometry as a property of the polygon feature. Break it into its own feature here.
                    const centroid = {};
                    if ('centroid' in feature.properties && 'coordinates' in feature.properties.centroid) {
                        centroid.geometry = feature.properties.centroid;
                        delete feature.properties.centroid;
                        centroid.properties = feature.properties;
                        lotData[lot_no].centroid = centroid.geometry.coordinates;

                        // Push our centroid as point geometry
                        geojsonData.features.push(centroid);
                    }

                    // Save the bounding box
                    // eslint-disable-next-line camelcase
                    if ('bbox' in feature && lot_no != null) {
                        lotData[lot_no].bbox = feature.bbox;
                        delete feature.bbox;
                    }

                    geojsonData.features.push(feature);
                }
            })
            .always(function () {
                // Set or expand the bounding box for all data
                if (allBBox.length) {
                    // enlarge the bounding box if necessary
                    if (allBBox[0] > sgbbox[0]) {
                        allBBox[0] = sgbbox[0];
                    }
                    if (allBBox[1] > sgbbox[1]) {
                        allBBox[1] = sgbbox[1];
                    }
                    if (allBBox[2] < sgbbox[2]) {
                        allBBox[2] = sgbbox[2];
                    }
                    if (allBBox[3] < sgbbox[3]) {
                        allBBox[3] = sgbbox[3];
                    }
                } else {
                    allBBox = sgbbox;
                }
                // Resolve the deferred wrapper after success or failure
                ajaxDeferredWrapper.resolve();
            });
    });
}

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export async function createMap() {
    await prepareMap('cartographer_prefs');
    await initializeMapData('maps/active_lots.geojson.json', true);
    setupMapInteractions();
}

export async function createGovtMap() {
    await prepareMap('govt_list_prefs');
    prefs.showMap ? showMap() : hideMap();
    setToggleMap();

    // Create an index of all the lots we are displaying on this page.
    // We will use this list to prune any lots in the geojson that are no longer active on this page
    const allLots = window.saleGroupTables.rows().nodes().to$(); // get jquery selector for unrendered rows

    // if we dont have a datatable look for hidden list of lots in sale group
    (allLots.length ? allLots : $('.sale-group-lots [data-lot-number]')).each(function () {
        lotData[$(this).data('lotNumber')] = {};
    });

    await initializeMapDataGovt('.sale-group[data-sale-group]');

    // Wait for all ajax requests to wrap up and do the following regardless of success
    $.when.apply(this, mapPromises).done(function () {
        addAdditionalLayersGovt(geojsonData);
        // Setup map interactions
        setupMapInteractionsGovt(saleGroupData, lotData);
    });
}

var isMapSetup = false;

export async function createBlazorMap(mapJson) {
    const data = JSON.parse(mapJson);

    if (!isMapSetup) {
        await prepareMap('cartographer_prefs');
        map.on('load', async function () {
            await initializeMapData(data, false);

            setupMapInteractions();
            isMapSetup = true;
        });
    }
    else {
        await initializeMapData(data, false);
    }
}